import React from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { AuthPayloadSuccess } from '../../lib/authenticate';
import { PasswordSignIn } from './PasswordSignIn';
import { PasswordlessSignIn } from './PasswordlessSignIn';

export type SignInFormValues = {
  signInEmail: string;
  signInPassword: string;
  signInRemember: boolean;
};

export type SignInProps = {
  title?: string;
  message?: string;
  className?: string;
  showSocialAuth?: boolean;
  showCancelButton?: boolean;
  defaultValues?: Partial<SignInFormValues>;
  changePayment?: () => void;
  showAuthModal?: () => void;
  hideAuthModal?: () => void;
  onClickForgotPassword?: () => void;
  onAuth: (authUser?: AuthPayloadSuccess) => void;
};

const SIGN_IN_TITLE = 'Have an Account?';
const SIGN_IN_MESSAGE =
  'Sign in to speed up the checkout process, check your order status and save your favorite products.';

export const SignIn: React.FC<SignInProps> = ({
  onAuth,
  className,
  showSocialAuth = true,
  showCancelButton,
  defaultValues,
  showAuthModal,
  hideAuthModal,
  changePayment,
  onClickForgotPassword,
  title = SIGN_IN_TITLE,
  message = SIGN_IN_MESSAGE
}) => {
  const passwordlessEnabled = useFeatureFlag('passwordless-login', [
    { default: false },
    { if: true, then: true }
  ]);

  if (passwordlessEnabled) {
    return (
      <PasswordlessSignIn
        changePayment={changePayment}
        className={className}
        defaultValues={defaultValues}
        hideAuthModal={hideAuthModal}
        onAuth={onAuth}
        showAuthModal={showAuthModal}
        showSocialAuth={showSocialAuth}
        showCancelButton={showCancelButton}
        title={title}
      />
    );
  }

  return (
    <PasswordSignIn
      changePayment={changePayment}
      className={className}
      defaultValues={defaultValues}
      hideAuthModal={hideAuthModal}
      message={message}
      onAuth={onAuth}
      onClickForgotPassword={onClickForgotPassword}
      showAuthModal={showAuthModal}
      showSocialAuth={showSocialAuth}
      showCancelButton={showCancelButton}
      title={title}
    />
  );
};

export { FORGOT_PASSWORD_TEXT } from './PasswordSignIn';
